enum USER_JOURNEY_CARDS {
  KYC = 'kyc',
  ADD_BANK = 'add_bank',
  DEPOSIT = 'deposit',
  TRADE = 'trade',
  THIRTY_DAYS = '30_days_journey',
}

interface CardProps {
  loading: boolean;
  onCloseRequest: () => Promise<void>;
}
export type { CardProps };
export { USER_JOURNEY_CARDS };
